import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Check } from "lucide-react";
import { Shell } from "@/components/Shell";
import { QuestionField } from "@/components/QuestionField";
import { getStaffQuestions } from "@/data/staff";
import { getSubmission, upsertStaff } from "@/lib/storage";

export default function StaffSurveyPage() {
  const { id, staffId } = useParams();
  const navigate = useNavigate();
  const [entry, setEntry] = useState(() => getSubmission(id)?.staff?.find((p) => p.id === staffId) || null);
  const questions = getStaffQuestions(getSubmission(id)?.businessType);

  if (!entry) {
    navigate(`/risultato/${id}`, { replace: true });
    return null;
  }

  const setAnswer = (qid, v) => setEntry(upsertStaff(id, { ...entry, answers: { ...entry.answers, [qid]: v } }));
  const done = () => {
    upsertStaff(id, { ...entry, status: "completed", completedAt: new Date().toISOString() });
    navigate(`/staff/${id}/${staffId}/grazie`, { replace: true });
  };

  return (
    <Shell header={<span className="text-sm text-[#7A6B63]" data-testid="staff-respondent">{entry.name} · {entry.role}</span>}>
      <div className="fade-up">
        <p className="eyebrow">Voce dello staff</p>
        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#2C221E] mt-2">Come la vedi tu</h1>
        <p className="text-[#5C4D46] mt-3">Risposte sincere, nessuna è sbagliata. Si salvano da sole.</p>
        <div className="mt-10 grid gap-10">
          {questions.map((q, i) => (
            <div key={q.id} className="card p-6 sm:p-8" data-testid={`staff-question-${q.id}`}>
              <div className="flex gap-4 items-start mb-5">
                <span className="flex-none font-serif text-2xl font-semibold text-[#C85A32] leading-none mt-0.5">{i + 1}</span>
                <div>
                  <p className="text-lg sm:text-xl font-semibold text-[#2C221E] leading-snug">{q.text}</p>
                  {q.hint && <p className="text-sm text-[#7A6B63] mt-1">{q.hint}</p>}
                </div>
              </div>
              <QuestionField q={q} value={entry.answers[q.id]} onChange={(v) => setAnswer(q.id, v)} />
            </div>
          ))}
        </div>
        <div className="flex justify-end mt-10">
          <button className="btn btn-primary text-lg !min-h-[64px] !px-9" onClick={done} data-testid="submit-staff-survey-btn"><Check size={20} /> Ho finito, consegno</button>
        </div>
      </div>
    </Shell>
  );
}
